export default "__VITE_ASSET__tYT_R1jj__"